import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@shared/components/dialog/Dialog';
import DialogContent from '@shared/components/dialog/DialogContent';
import DialogActions, { Justify } from '@shared/components/dialog/DialogActions';
import Button from '@shared/components/button';
import Typography from '@material-ui/core/Typography';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import transitions from '@material-ui/core/styles/transitions';
import zIndex from '@material-ui/core/styles/zIndex';

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    overflow: 'auto',
    display: 'flex',
    padding: '0 16px',
  },
  button: {
    color: theme.palette.common.darkGrey,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.darkGrey}`,
    borderRadius: '0.4rem',
  },
  productDrawerPaper: {
    minWidth: '1250px',
    maxWidth: '66%',
  },
  title: {
    padding: 0,
  },
  titleTypography: {
    fontSize: '1.8rem',
    lineHeight: '27px',
    fontWeight: 500,
  },
  closeButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignSelf: 'center',
    padding: 0,
    position: 'relative',
    top: '8px',
    right: '8px',
    '& > .MuiTouchRipple-root': {
      color: '#fff',
    },
  },
}));

const ProductImageFormDialog = ({
  open,
  Form,
  FormProps,
  title,
  content,
  onCancel,
  onClose,
  onSave,
  saveButtonText = 'Save',
  cancelButtonText = 'Cancel',
  isSaveDisabled,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={ open }
      onClose={ onClose }
      PaperComponent={ Form }
      PaperProps={ FormProps }
      drawerPaperProps={ { className: classes.productDrawerPaper } }
      isDrawer
    >
      <MuiDialogTitle className={ classes.title } disableTypography>
        <IconButton
          aria-label="close"
          className={ classes.closeButton }
          onClick={ onCancel }
        >
          <CloseIcon fontSize="large" htmlColor="black" />
        </IconButton>
        <Typography variant="h4" component="h2" align="center" className={ classes.titleTypography }>
          {title}
        </Typography>
      </MuiDialogTitle>

      <DialogContent className={ classes.dialogContent }>{content}</DialogContent>
    </Dialog>
  );
};

export default ProductImageFormDialog;
